import api from "@/lib/axios";

export const getRevenue = async ({ period, branchId, offset, from, to }) => {
  const { data } = await api.get("/revenue", {
    params: {
      period,
      offset: offset || undefined,
      branchId: branchId ?? undefined,
      from: from ?? undefined,
      to: to ?? undefined,
    },
  });

  return data.data;
};

export const syncRevenue = async () => {
  const { data } = await api.post("/revenue/sync");

  return data.data;
};

export const getDailySales = async ({ period, offset, from, to, branchId }) => {
  const { data } = await api.get("/revenue/daily-sales", {
    params: {
      period,
      offset: offset || undefined,
      from: from ?? undefined,
      to: to ?? undefined,
      branchId: branchId ?? undefined,
    },
  });

  return data.data;
};
